<template>
    <div id="app">
        <NavTop v-if="$router.currentRoute.name!=404"></NavTop>
        <router-view></router-view>
        <NavNottom v-if="$router.currentRoute.name!=404"></NavNottom>
        <el-popover
            placement="top"
            title=""
            width="150"
            trigger="hover"
            >
            <img
            style="width: 150px; height: 150px;display: block;"
            src="./assets/images/weixinkefu.png"
            >
            <div v-if="$router.currentRoute.name!=404" slot="reference" class="qqrelation">
                <div class="qqtop">
                    <div class="iconfont icon-weixin1"></div>
                    <div>微信客服</div>
                </div>
                <div class="qqbottom">
                    在线联系
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script>
import NavTop from '@/components/nav/navtop.vue'
import NavNottom from '@/components/nav/navBottom.vue'
import { mapMutations, mapState, mapActions } from 'vuex'
export default {
    name: 'App',
    created() {
        // localStorage.setItem('qwe','!@#!@#');
        //在页面加载时读取sessionStorage里的状态信息
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
        }
        // let token = localStorage.getItem('token');
        // if(token)  this.$store.commit('settoken',token);
        //在页面刷新时将vuex里的信息保存到sessionStorage里
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state))
        })
        // let cokie = this.xin.getCookie('GsToken')||localStorage.getItem('GsToken');
        // if(cokie){

        // }else{
        // 	localStorage.removeItem("token");
        // }
    },
    mounted() {

    },
    computed: {
        ...mapState(['isChecked'])
    },
    components: {
        NavTop,
        NavNottom
    },
    methods: {
        ...mapMutations(['setclassName', 'setisChecked', 'settoken']),
        ...mapActions(['setgoodsCount', 'getUser']),
    }
}
</script>

<style lang="scss">
#app {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    width: 100%;
    height: auto;
}

//其他
.qqrelation {
    position: fixed;
    right: 0px;
    bottom: 70px;
    width: 140px;
    height: 80px;
    border: 1px solid var(--themeColor);
    cursor: pointer;
    z-index: 999;
    background: #fff;
    .qqtop {
        background: var(--themeColor);
        height: 50px;
        color: #fff;
        text-align: center;
        display:flex;
        align-items: center;
        justify-content: center;
        .iconfont {
            font-size: 30px;
            // line-height: 30px;
        }
    }
    .qqbottom {
        font-size: 20px;
        text-align: center;
        color: #005599;
        line-height: 30px;
        height: 30px;
        background: #fff;
    }
}
body {
    padding: 0;
    margin: 0;
}
</style>
